import PropTypes from 'prop-types';
import { PaginationInformation, PageSelection, PageSizeSelector } from "./components";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const Pagination = _ref => {
  let {
    pageNumber,
    pageSize,
    setPageNumber,
    setPageSize,
    totalItemCount,
    totalPageCount,
    scrollPaginationElement,
    showPageSizeSelector = true,
    showLabels = true
  } = _ref;
  return /*#__PURE__*/_jsxs("nav", {
    "aria-label": "Table navigation",
    "data-test-element": "table-navigation",
    className: "flex justify-between items-end text-14px space-x-4",
    children: [/*#__PURE__*/_jsx(PaginationInformation, {
      className: "sm:hidden lg:block font-regular-font text-text-blue",
      pageNumber: pageNumber,
      pageSize: pageSize,
      totalItemCount: totalItemCount
    }), totalItemCount ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(PageSelection, {
        className: "flex-grow max-w-3xl",
        pageNumber: pageNumber,
        showLabels: showLabels,
        setPageNumber: setPageNumber,
        totalPageCount: totalPageCount,
        scrollPaginationElement: scrollPaginationElement
      }), showPageSizeSelector ? /*#__PURE__*/_jsx(PageSizeSelector, {
        setPageNumber: setPageNumber,
        pageSize: pageSize,
        setPageSize: setPageSize
      }) : null]
    }) : null]
  });
};
Pagination.propTypes = {
  pageNumber: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  setPageNumber: PropTypes.func.isRequired,
  setPageSize: PropTypes.func.isRequired,
  totalItemCount: PropTypes.number.isRequired,
  totalPageCount: PropTypes.number.isRequired,
  scrollPaginationElement: PropTypes.func.isRequired,
  showPageSizeSelector: PropTypes.bool,
  showLabels: PropTypes.bool
};
export default Pagination;
//# sourceMappingURL=Pagination.js.map